module.exports = __webpack_public_path__ + "img/kit.b9a14849.png";